const nb = require('./resources/nb.json');

export default {
    messages: nb,
    formats: {
        date: {
            short: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            },
        },
        number: {
            price: {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};
